

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

const MobileNav = () => {
  const isMobile = useIsMobile();
  
  if (!isMobile) {
    return null;
  }
  
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-navy-dark border-b border-tan/20 py-2 px-4">
      <Link to="/brotocol">
        <Button 
          variant="outline" 
          className="w-full text-tan border-tan hover:bg-navy"
        >
          📜 View Brotocol Manifesto
        </Button>
      </Link>
    </div>
  );
};

export default MobileNav;
